export function parseDecimal(value) {
    const rawValue = (value || '').replace(/\D/g, '');
    const unsafeDecimal = parseInt(rawValue, 10);
    return Number.isNaN(unsafeDecimal) ? 0 : unsafeDecimal;
}
//# sourceMappingURL=parseDecimal.js.map